import { render, staticRenderFns } from "./contract-local-dialog.vue?vue&type=template&id=5241cfc8&scoped=true"
import script from "./contract-local-dialog.vue?vue&type=script&lang=js"
export * from "./contract-local-dialog.vue?vue&type=script&lang=js"
import style0 from "./contract-local-dialog.vue?vue&type=style&index=0&id=5241cfc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5241cfc8",
  null
  
)

export default component.exports